import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative flex items-center gap-2" }
const _hoisted_2 = { class: "shrink-0 text-sm font-bold" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = ["value"]

import { computed } from "vue";
import { storeToRefs } from "pinia";

import { useLocationsStore } from "~/js/store/locations";
import { Translations } from "~/js/interfaces/translations";
import { getTranslation } from "~/js/composables/translations";

interface Props {
	translations?: Translations | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SortLocations',
  props: {
    translations: { default: null }
  },
  setup(__props: any) {

const props = __props;

const locationsStore = useLocationsStore();
const { sortMode } = storeToRefs(locationsStore);

const sortBy = computed<"alphabetical" | "recent">({
	get: () => sortMode.value,
	set: (value) => locationsStore.setSorting(value),
});

const sortOptions = computed(() => [
	{
		value: "alphabetical" as const,
		label: getTranslation(props.translations, "Alphabetical"),
	},
	{
		value: "recent" as const,
		label: getTranslation(props.translations, "Recently added"),
	},
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(getTranslation)(__props.translations, "Sort by")), 1),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sortBy).value = $event)),
        class: "w-28 appearance-none truncate rounded-full border border-concrete-500 bg-white py-2 pl-3 pr-9 text-sm font-medium text-black md:min-w-36 md:pl-4 md:pr-10"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortOptions.value, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: option.value,
            value: option.value
          }, _toDisplayString(option.label), 9, _hoisted_4))
        }), 128))
      ], 512), [
        [_vModelSelect, sortBy.value]
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-black",
        "aria-hidden": "true"
      }, [
        _createElementVNode("i", { class: "far fa-chevron-down text-sm" })
      ], -1))
    ])
  ]))
}
}

})